<ng-container
  *ngIf="{
    req: req$ | async,
  } as content"
>
  <div class="container-modal-modify-motor">
    <div class="container-iframe">
      @if (!content.req?.isPristine) {
        @if (!content.req?.isLoading) {
          @if (!content.req?.hasError) {
            @if (content.req?.iframeConfigs?.initParams) {
              <iframe
                [src]="content.req?.iframeConfigs?.initParams"
                class="w-100"
                frameborder="0"
                sandbox="allow-scripts allow-popups allow-forms allow-top-navigation"
              >
              </iframe>
              <!-- <local-loader></local-loader> -->
            } @else {
              <p class="text-center ff-bold m-0">{{ 'modifyMotors.noContent' | cxTranslate }}</p>
            }
          } @else {
            <alert [alert]="alertMessage"></alert>
          }
        } @else {
          <local-loader></local-loader>
        }
      }
    </div>
  </div>
</ng-container>